module.exports = __webpack_public_path__ + "media/ending_soon.8e80a6b1.mp3";